<template>
    <div class="layout-meja">
        <div class="zoom-buttons px-2 pt-2">
            <div class="d-flex align-center" style="gap: 10px;">
                <v-btn @click="zoomIn" depressed fab x-small>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" viewBox="0 0 24 24">
                        <path
                            d="M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14M12,10H10V12H9V10H7V9H9V7H10V9H12V10Z" />
                    </svg>
                </v-btn>
                <v-btn @click="zoomOut" depressed fab x-small>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" viewBox="0 0 24 24">
                        <path
                            d="M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5A6.5,6.5 0 0,0 9.5,3A6.5,6.5 0 0,0 3,9.5A6.5,6.5 0 0,0 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z" />
                    </svg>
                </v-btn>
                <v-btn @click="resetZoom" depressed fab x-small>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" viewBox="0 0 24 24">
                        <path
                            d="M12,3A9,9 0 0,0 3,12H0L4,16L8,12H5A7,7 0 0,1 12,5A7,7 0 0,1 19,12A7,7 0 0,1 12,19C10.5,19 9.09,18.5 7.94,17.7L6.5,19.14C8.04,20.3 9.94,21 12,21A9,9 0 0,0 21,12A9,9 0 0,0 12,3M14,12A2,2 0 0,0 12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12Z" />
                    </svg>
                </v-btn>
            </div>
            <div class="d-flex align-center" style="gap: 10px;">
                <v-btn @click="moveUp" depressed fab x-small>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" viewBox="0 0 24 24">
                        <path d="M7.03 13.92H11.03V5L13.04 4.97V13.92H17.03L12.03 18.92Z" />
                    </svg>
                </v-btn>
                <v-btn @click="moveDown" depressed fab x-small>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" viewBox="0 0 24 24">
                        <path d="M7.03 9.97H11.03V18.89L13.04 18.92V9.97H17.03L12.03 4.97Z" />
                    </svg>
                </v-btn>
                <v-btn @click="moveRight" depressed fab x-small>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" viewBox="0 0 24 24">
                        <path d="M10.05 16.94V12.94H18.97L19 10.93H10.05V6.94L5.05 11.94Z" />
                    </svg>
                </v-btn>
                <v-btn @click="moveLeft" depressed fab x-small>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" viewBox="0 0 24 24">
                        <path d="M14 16.94V12.94H5.08L5.05 10.93H14V6.94L19 11.94Z" />
                    </svg>
                </v-btn>
            </div>
        </div>
        <div class="container" id="containerLayout" ref="containerLayout">
            <div
                id="inner"
                ref="zoom"
                @touchstart="startTouch"
                @touchmove="moveTouch"
                @touchend="endTouch"
                @gesturestart="startGesture"
                @gesturechange="zoomGesture"
                @gestureend="endGesture"
                >
                <img :src="layoutImage" alt="" />

                <div
                    v-for="(content, index) in customContent"
                    :key="index"
                    :class="`content_${getUrlDomain}_${index} custom-content`"
                >
                    <!-- {{ content?.content }} -->
                    <div class="item" v-html="content?.content"></div>
                </div>

                <button
                    v-for="(item, index) in meja" 
                    :key="index + item.id + item.name" 
                    :data-id="item.id"
                    :data-name="item.name"
                    :data-date="reserveDate?.date"
                    :class="`${getUrlDomain}_${item.name} ${item.name}-${item.id} ${item.name} ${item.name}-${reserveDate?.date} meja`"
                    elevation="0" @click="tableClicked(index)" @touchend="tableClicked(index)" :disabled="isInactived(item)" :style="{
                        padding: !isSeatItemSelected(item) && !isInactived(item) ? `5px!important` : `0px`,
                        width: [1, 4].includes(tableModel(item)) ? `${rectButtonWidth}px!important` : tableModel(item) === 3 ? `${circleButtonWidth}px!important` : `${buttonWidth}px!important`,
                        height: [1, 4].includes(tableModel(item)) ? `${rectButtonHeight}px!important` : tableModel(item) === 3 ? `${circleButtonHeight}px!important` : `${buttonHeight}px!important`,
                        border: isSelectedAndIactive(item) ? `1px solid red!important` : isSeatItemSelected(item) ? `1px solid #178217!important` : `1px solid #272727!important`,
                        cursor: isInactived(item) ? `not-allowed` : `pointer`,
                        backgroundColor: isSelectedAndIactive(item) ? '#fe5a5a' : isSeatItemSelected(item) ? '#1FAD1F' : isInactived(item) ? '#EEEEEE' : '#FAFAFA',
                        borderRadius: [3, 4].includes(tableModel(item)) ? `100px` : `2px`,
                        fontSize: [3, 4].includes(tableModel(item)) ? `${circleFontSize}px` : `${fontSize}px`,
                    }">
                    <svg v-if="isSeatItemSelected(item)" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="15"
                        height="15" viewBox="0 0 24 24">
                        <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                    </svg>
                    <svg v-else-if="isInactived(item)" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <path d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" />
                    </svg>
                    <span v-else-if="!isSeatItemSelected(item) && !isInactived(item)" class="blue--text">{{
                        item.name
                    }}</span>
                </button>
            </div>
        </div>
    </div>
</template>
  
<script>
import { mapGetters } from "vuex";
export default {
    props: {
        meja: {
            type: Array,
            default: () => [],
        },
        reserveDate: {
            type: Object,
            default: () => { },
        },
        customContent: {
            type: Array,
            default: () => [],
        },
        size: String,
        layoutImage: String,
        zoomScale: Number,
        x: Number,
        y: Number,
        buttonWidth: { type: Number, default: 18 },
        buttonHeight: { type: Number, default: 18 },
        rectButtonWidth: { type: Number, default: 30 },
        rectButtonHeight: { type: Number, default: 14 },
        circleButtonWidth: { type: Number, default: 18 },
        circleButtonHeight: { type: Number, default: 18 },
        fontSize: { type: Number, default: 5 },
        circleFontSize: { type: Number, default: 4 }
    },
    mounted() {
        this.initializeZoom();
    },
    data() {
        return {
            imageLayout: "",
            scale: 1,
            panning: false,
            pointX: 0,
            pointY: 0,
        };
    },
    watch: {
        layoutImage(value) {
            console.log("imageLayout", value)
            this.imageLayout = value
        },
        zoomScale(value) {
            this.scale = value
            this.setTransform();
        },
        x(value) {
            this.pointX = value
            this.setTransform();
        },
        y(value) {
            this.pointY = value
            this.setTransform();
        },
        // scale(value) {
        //     console.log("scale", value)
        // },
        // pointX(value) {
        //     console.log("pointX", value)
        // },
        // pointY(value) {
        //     console.log("pointY", value)
        // }
    },
    computed: {
        cartReservations() {
            return this.$store.getters.dataCartReservation;
        },
        ...mapGetters(["getUrlDomain"]),
    },
    methods: {
        itemsWithSameDate() {
            return this.cartReservations.filter(
                (cart) => cart.reservation_date.date === this.reserveDate?.date
            )
        },
        isInactived(item) {
            return item?.is_table_booked == 1 || !item?.item_place_reservation
            // return false
        },
        isSeatItemSelected(item) {
            const list_cart = this.cartReservations.filter(
                (cart) => cart.reservation_date.date === this.reserveDate?.date
            )
            return list_cart.some(
                (selected) => selected.name === item.name
            );
        },
        isSelectedAndIactive(item) {
            return this.isSeatItemSelected(item) && this.isInactived(item)
        },
        tableModel(item) {
            return item?.item_place_reservation?.table_model
        },
        // Zoom Action
        initializeZoom() {
            const zoom = this.$refs.zoom;
            const trackpadSensitivity = 0.005;
            const containerElement = document.getElementById('containerLayout');

            zoom.onmousedown = (e) => {
                e.preventDefault();
                this.start = { x: e.clientX - this.pointX, y: e.clientY - this.pointY };
                this.panning = true;
                // containerElement?.addEventListener('mouseleave', this.stopDrag);
                this.$refs.containerLayout?.addEventListener('mouseleave', this.stopDrag);
            };

            zoom.onmouseup = () => {
                this.panning = false;
            };

            zoom.onmousemove = (e) => {
                e.preventDefault();
                if (!this.panning) {
                    return;
                }
                this.pointX = e.clientX - this.start.x;
                this.pointY = e.clientY - this.start.y;
                this.setTransform();
            };

            // // Zoom saat cubit trackpad laptop
            // zoom.onwheel = (e) => {
            //     e.preventDefault();
            //     const xs = (e.clientX - this.pointX) / this.scale;
            //     const ys = (e.clientY - this.pointY) / this.scale;
            //     let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
            //     delta *= trackpadSensitivity;
            //     this.scale *= delta > 0 ? 1.2 : 1 / 1.2;
            //     this.pointX = e.clientX - xs * this.scale;
            //     this.pointY = e.clientY - ys * this.scale;
            //     setTransform.call(this);
            // };
        },

        stopDrag() {
            this.panning = false;
        },

        startTouch(e) {
            e.preventDefault();
            if (e.touches.length === 1) {
                this.start = { x: e.touches[0].clientX - this.pointX, y: e.touches[0].clientY - this.pointY };
                this.panning = true;
            }
            if (e.touches.length === 2) {
                this.startPinchScale = this.scale;
                this.initialDistance = Math.hypot(
                    e.touches[0].clientX - e.touches[1].clientX,
                    e.touches[0].clientY - e.touches[1].clientY
                );
            }
        },

        moveTouch(e) {
            e.preventDefault();
            if (this.panning && e.touches.length === 1) {
                this.pointX = e.touches[0].clientX - this.start.x;
                this.pointY = e.touches[0].clientY - this.start.y;
                this.setTransform();
            }
            if (e.touches.length === 2) {
                const currentDistance = Math.hypot(
                    e.touches[0].clientX - e.touches[1].clientX,
                    e.touches[0].clientY - e.touches[1].clientY
                );
                const deltaScale = currentDistance / this.initialDistance;

                this.scale = this.startPinchScale * deltaScale;
                this.setTransform();
            }
        },

        endTouch() {
            e.preventDefault();
            this.panning = false;
        },
        startGesture(e) {
            e.preventDefault();
        },


        moveUp() {
            this.pointY -= 10;
            this.setTransform();
        },

        moveDown() {
            this.pointY += 10;
            this.setTransform();
        },

        moveLeft() {
            this.pointX -= 10;
            this.setTransform();
        },

        moveRight() {
            this.pointX += 10;
            this.setTransform();
        },

        zoomGesture(e) {
            e.preventDefault();
            this.scale *= e.scale;
            this.pointX = e.clientX - (e.clientX - this.pointX) * e.scale;
            this.pointY = e.clientY - (e.clientY - this.pointY) * e.scale;
            this.setTransform();
        },

        endGesture() {
            this.panning = false;
            this.adjustViewAfterGesture();
        },

        adjustViewAfterGesture() {
            if (this.scale < 1) {
                this.scale = this.zoomScale ?? 1;
                this.pointX = this.x ?? 0;
                this.pointY = this.y ?? 0;
                this.setTransform();
            } else if (this.scale > 4) {
                this.scale = 4; // Atur batasan maksimum zoom
                this.setTransform();
            }
        },

        zoomIn() {
            this.scale *= 1.2;
            this.setTransform();
        },

        zoomOut() {
            this.scale /= 1.2;
            this.setTransform();
        },

        resetZoom() {
            this.scale = this.zoomScale ?? 1;
            this.pointX = this.x ?? 0;
            this.pointY = this.y ?? 0;
            this.setTransform();
        },

        tableClicked(index) {
            const table = this.meja[index];
            const tableClass = `${table.name}-${table.id}`;
            const tableElement = this.$el.querySelector(`.${tableClass}`);
            const tableRect = tableElement.getBoundingClientRect();
            const zoomRect = this.$refs.zoom.getBoundingClientRect();

            const left = (tableRect.left - zoomRect.left) / this.scale;
            const top = (tableRect.top - zoomRect.top) / this.scale;

            // alert(`Table ${table.name} clicked! Left: ${left}, Top: ${top}`);
            // console.log(`Table `, this.isInactived(table));
            if (!this.isInactived(table)) {
                this.$emit("click", table);
            }
        },

        setTransform() {
            const zoom = this.$refs.zoom;
            zoom.style.transform = `translate(${this.pointX}px, ${this.pointY}px) scale(${this.scale})`;
        },

        setCenterTransform() {
            const containerWidth = this.$refs.containerLayout.offsetWidth;
            const containerHeight = this.$refs.containerLayout.offsetHeight;
            const x = containerWidth / 2 - containerWidth / 2 * this.scale;
            const y = containerHeight / 2 - containerHeight / 2 * this.scale;
            const zoom = this.$refs.zoom;
            zoom.style.transform = `translate(${x}px, ${y}px) scale(${this.scale})`;
        }
        // End Zoom Action
    },
};
</script>
  
<style scoped>
* {
    box-sizing: border-box;
}

.container {
    position: relative;
    border: solid 1px red;
    height: initial;
    width: 100%;
    max-width: 600px;
    overflow: auto;
    padding: 0;
}

#inner {
    width: 100%;
    height: 100%;
    transform-origin: 0px 0px;
    transform: scale(1) translate(0px, 0px);
    cursor: grab;
}

div#inner>img {
    width: 100%;
    height: auto;
}

.meja {
    position: absolute;
    width: 50px;
    height: 50px;
    background-color: #007bff;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    border: none;
    outline: none;
    user-select: none;
}

button.v-btn.v-btn--disabled.v-btn--has-bg.v-size--default.meja {
    background: #ccc !important;
}

.zoom-buttons {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: 10px;
    background-color: rgb(227 226 226 / 51%);
    border-radius: 8px 8px 0 0;
}
</style>
  